import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import EventBus from "./EventBus";

Vue.use(Vuex);

let store = new Vuex.Store({
  state() {
    let abo = null,
      templates = null,
      page = null,
      moderator = null;
    let initData;
    let aboNumber = null;
    let amwayOrigin = null;
    /*await fetch(`${process.env.VUE_APP_API_ROOT}/api/v2/session`, {
      method: "POST",
      credentials: "include"
    })
      .then(r => r.json())
      .then(r => {
        if (r.result) {
          initData = r.result;
        }
      })*/

    if (initData) {
      if (initData.abo) {
        abo = initData.abo;
        window.dataLayer = [
          {
            userId: abo.abo_number
          }
        ];
      }
      templates = initData.templates;
      page = initData.page;
      if (initData.moderator) {
        moderator = Object.assign(initData.moderator, {
          stats: initData.moderation_stats
        });
      }
    }
    //Init GA

    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-WCZF3JC");
    return {
      isKZ: /^kz/.test(window.location.host),
      user: abo,
      page: page,
      userTypes: {
        abo: abo
          ? abo.user_type.filter(ut => ut.code === "abo").length > 0
          : false,
        vip: abo
          ? abo.user_type.filter(ut => ut.code === "vip").length > 0
          : false
      },
      constructorData: {
        templates: templates,
        selectedTemplate: templates
          ? templates.find(t => t.id === page.template.id)
          : null
      },
      moderator: moderator,
      login: {
        waitingServer: false,
        error: false
      },
      app: {
        loading: false
      }
    };
  },
  getters: {
    getComponentByName: state => name => {
      if (state.page) {
        return state.page.components.find(item => item.type === name);
      }
      return null;
    },
    getAllComponents: state => {
      if (state.page) {
        return state.page.components;
      }
      return [];
    },
    idFromType: (state, getters) => type => {
      return getters.getAllComponents.find(item => {
        return item.type === type;
      }).id;
    },
    isEnabled: (state, getters) => type => {
      const found = getters.getAllComponents.find(item => {
        return item.type === type;
      });
      if (found) {
        return found.enabled;
      }
      return false;
    }
  },
  mutations: {
    setSecurity(state, payload) {
      state.security = payload;
    },
    setPageEnabled(state, payload) {
      state.page.enabled = payload;
    },
    setAvatar(state, payload) {
      state.page.components.find(
        item => item.type === "Profile"
      ).content.avatar = payload;
    },
    setUser(state, payload) {
      state.user = payload;
      state.userTypes = {
        abo: payload
          ? payload.user_type.filter(ut => ut.code === "abo").length > 0
          : false,
        vip: payload
          ? payload.user_type.filter(ut => ut.code === "vip").length > 0
          : false
      };
    },
    setPage(state, payload) {
      state.page = payload;
      if (state.constructorData && state.constructorData.templates) {
        state.constructorData.selectedTemplate = state.constructorData.templates.find(
          t => t.id === payload.template.id
        );
      }
    },
    setTemplates(state, payload) {
      payload = payload.map(t => {
        if (t.cover) {
          t.cover = process.env.VUE_APP_API_ROOT + "/" + t.cover;
        }
        return t;
      });
      if (state.constructorData) {
        state.constructorData.templates = payload;
      } else {
        state.constructorData = { templates: payload };
      }
    },
    replaceComponent(state, payload) {
      if (!state.page) {
        return false;
      }
      const pageCopy = Object.assign({}, state.page);
      pageCopy.components.forEach((item, index) => {
        if (item.id === payload.id) {
          pageCopy.components[index] = payload;
        }
      });
      state.page = pageCopy;
    },
    updateComponent(state, payload) {
      const component = state.page.components.find(item => {
        return item.id === payload.id;
      });
      for (let key in component) {
        if (payload[key]) {
          component[key] = payload[key];
        }
      }
    },
    wizardStepChange(state, payload) {
      state.user.step = payload;
    },
    setModerator(state, payload) {
      state.moderator = payload;
      localStorage.setItem("moderator", JSON.stringify(payload));
    }
  },
  actions: {
    appStart({ commit, dispatch, state }) {
      state.app.loading = true;
      const user = JSON.parse(localStorage.getItem("user"));
      const page_id = JSON.parse(localStorage.getItem("page_id"));
      const templates = JSON.parse(localStorage.getItem("templates"));
      const security = JSON.parse(localStorage.getItem("security_state"));
      commit("setUser", user);
      if (!security) {
        state.security.nonce = `${Math.random()
          .toString(32)
          .replace("0.", "") +
          Math.random()
            .toString(32)
            .replace("0.", "")}`;
        state.security.state = `${Math.random()
          .toString(32)
          .replace("0.", "") +
          Math.random()
            .toString(32)
            .replace("0.", "") +
          Math.random()
            .toString(32)
            .replace("0.", "")}`;
        localStorage.setItem("security_state", JSON.stringify(state.security));
      } else {
        state.security.state = security.state;
        state.security.nonce = security.nonce;
      }
      if (templates) {
        commit("setTemplates", templates);
      }
      Vue.axios({
        method: "GET",
        url: `template/get/?uid=${user.id}`
      })
        .then(resp => {
          commit("setTemplates", resp.data.result);
          return Vue.axios({
            method: "get",
            url: `page/get/${page_id}`
          });
        })
        .then(function(response) {
          state.app.loading = false;
          return commit("setPage", response.data.result);
        })
        .then(function() {
          return dispatch("refreshUser");
        })
        .catch(function(error) {
          console.log(error);
          dispatch("logoutAction");
        });
    },
    logoutAction() {
      return fetch(`${process.env.VUE_APP_API_ROOT}/api/logout`, {
        method: "POST"
      })
        .then(() => {
          window.location.href = `${process.env.VUE_APP_SSO_HOST_2}signout?clientapp=amwaypersonalpages&redirect=https://${window.location.host}`;
        })
        .catch(() => (window.location.href = window.location.origin));
    },
    loginAction({ commit, state }, payload) {
      state.login.waitingServer = true;
      Vue.axios({
        method: "post",
        url: "auth",
        data: payload
      })
        .then(function(response) {
          state.login.waitingServer = false;
          state.login.error = false;
          commit("setUser", response.data.result.abo);
          commit("setTemplates", response.data.result.templates);
          commit("setPage", response.data.result.page);
          router.push("/");
        })
        .catch(function(error) {
          state.login.waitingServer = false;
          state.login.error = true;
          console.log(error);
        });
    },
    loginError({ state }) {
      state.login.waitingServer = false;
      state.login.error = true;
    },
    refreshUser({ commit, state }) {
      const formdata = new FormData();
      formdata.append("id", state.user.id);
      Vue.axios({
        method: "post",
        url: "user/post/",
        data: formdata
      })
        .then(function(response) {
          commit("setUser", response.data.result);
          EventBus.$emit("serverSyncSuccess", {
            msg: "Добро пожаловать!"
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    syncUser({ commit, state }, payload) {
      const formdata = new FormData();
      for (let key in payload) {
        formdata.append(key, payload[key]);
      }
      formdata.append("id", state.user.id);
      Vue.axios({
        method: "post",
        url: "user/post/",
        data: formdata
      })
        .then(function(response) {
          commit("setUser", response.data.result);
          EventBus.$emit("serverSyncSuccess", {
            msg: "Аккаунт обновлен"
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    setPageEnabled({ commit, state }, payload) {
      commit("setPageEnabled", payload);
      const data = {
        id: state.page.id,
        enabled: payload
      };
      const formdata = new FormData();
      for (let key in data) {
        formdata.append(key, data[key]);
      }
      Vue.axios({
        method: "post",
        url: "page/post/",
        data: formdata
      })
        .then(function() {
          EventBus.$emit("serverSyncSuccess", {
            msg: payload === true ? "Опубликовано" : "Снято с публикации"
          });
        })
        .catch(function(error) {
          console.log(error);
          EventBus.$emit("serverSyncError", {
            msg: "Ошибка сервера"
          });
        });
    },
    wizardStepChange({ commit, state }, payload) {
      commit("wizardStepChange", payload);
      const data = {
        id: state.user.id,
        step: payload
      };
      const formdata = new FormData();
      for (let key in data) {
        formdata.append(key, data[key]);
      }
      Vue.axios({
        method: "post",
        url: "user/post/",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formdata
      })
        .then(function() {
          EventBus.$emit("serverSyncSuccess", {
            msg: "Успешно"
          });
        })
        .catch(function(error) {
          console.log(error);
          EventBus.$emit("serverSyncError", {
            msg: "Ошибка сервера"
          });
        });
    },
    syncTemplate({ commit }, payload) {
      const formdata = new FormData();
      for (let key in payload) {
        formdata.append(key, payload[key]);
      }
      Vue.axios({
        method: "post",
        url: "page/post/",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formdata
      })
        .then(function(response) {
          EventBus.$emit("serverSyncSuccess", {
            msg: "Шаблон сохранен"
          });
          let new_page = response.data.result;
          const formdata = new FormData();
          for (let key in new_page.components[10]) {
            if (key === "component_type") {
              continue;
            }
            if (key === "type") {
              continue;
            }
            if (key === "content") {
              formdata.append(
                key,
                JSON.stringify(new_page.components[10][key])
              );
            } else {
              formdata.append(key, new_page.components[10][key]);
            }
          }
          Vue.axios({
            method: "post",
            url: "component/post/",
            headers: {
              "Content-Type": "multipart/form-data"
            },
            data: formdata
          });
          commit("setPage", new_page);
          // router.push("/edit");
        })
        .catch(function(error) {
          console.log(error);
          EventBus.$emit("serverSyncError", {
            msg: "Ошибка сервера"
          });
        });
    },
    syncComponent({ commit }, payload) {
      commit("updateComponent", payload);
      const formdata = new FormData();
      for (let key in payload) {
        if (key === "content") {
          formdata.append(key, JSON.stringify(payload[key]));
        } else {
          formdata.append(key, payload[key]);
        }
      }

      Vue.axios({
        method: "post",
        url: "component/post/",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formdata
      })
        .then(function(response) {
          EventBus.$emit("serverSyncSuccess", {
            msg: "Изменения сохранены"
          });
          return commit("replaceComponent", response.data.result);
        })
        .catch(function(error) {
          console.log(error);
          EventBus.$emit("serverSyncError", {
            msg: "Ошибка сервера"
          });
        });
    }
  }
});
export default store;
